import { computed, inject, Injectable, signal } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import {
  AdminLeadApiService,
  type AdminLeadStatsResponse,
} from '@nebalkon-workspace/lead-api';

@Injectable({ providedIn: 'root' })
export class StaffLeadsStatsService {
  readonly #api = inject(AdminLeadApiService);

  readonly #stats = signal<AdminLeadStatsResponse | null>(null);
  readonly #loading = signal(false);
  readonly #loaded = signal(false);
  readonly #accessDenied = signal(false);
  readonly #error = signal(false);

  readonly stats = this.#stats.asReadonly();
  readonly loading = this.#loading.asReadonly();
  readonly accessDenied = this.#accessDenied.asReadonly();
  readonly error = this.#error.asReadonly();

  readonly newTotal = computed(() => {
    const stats = this.#stats();
    if (!stats) {
      return 0;
    }

    return (
      stats.callbacks_new +
      stats.feedback_new +
      stats.vacancies_new +
      stats.birthdays_new +
      stats.foreign_registrations_new
    );
  });

  ensureLoaded(): void {
    if (this.#loaded() || this.#loading()) {
      return;
    }

    this.refresh();
  }

  refresh(): void {
    this.#loading.set(true);
    this.#accessDenied.set(false);
    this.#error.set(false);

    this.#api.getStats().subscribe({
      next: (stats) => {
        this.#stats.set(stats);
        this.#loaded.set(true);
        this.#loading.set(false);
      },
      error: (err: HttpErrorResponse) => {
        this.#loading.set(false);
        this.#loaded.set(true);
        if (err.status === 403) {
          this.#accessDenied.set(true);
        } else {
          this.#error.set(true);
        }
      },
    });
  }
}
